var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Card, Form, Input, Select, DatePicker, Button, Row, Col, Space, InputNumber, Switch, } from "antd";
import { SearchOutlined, ReloadOutlined, DownOutlined, UpOutlined, } from "@ant-design/icons";
var RangePicker = DatePicker.RangePicker;
var Option = Select.Option;
/**
 * 通用搜索面板组件
 */
var GenericPanelSearch = function (_a) {
    var 
    // 定义通用搜索面板组件
    _b = _a.title, 
    // 定义通用搜索面板组件
    title = _b === void 0 ? "搜索条件" : _b, // 设置默认标题
    _c = _a.searchItems, // 设置默认标题
    searchItems = _c === void 0 ? [] : _c, // 设置默认搜索项为空数组
    _d = _a.columns, // 设置默认搜索项为空数组
    columns = _d === void 0 ? 3 : _d, // 设置默认列数为3
    onSearch = _a.onSearch, // 设置搜索回调
    onReset = _a.onReset, // 设置重置回调
    _e = _a.extraButtons, // 设置重置回调
    extraButtons = _e === void 0 ? [] : _e, // 设置默认额外按钮为空数组
    _f = _a.collapsible, // 设置默认额外按钮为空数组
    collapsible = _f === void 0 ? true : _f, // 默认可折叠
    _g = _a.defaultCollapsed, // 默认可折叠
    defaultCollapsed = _g === void 0 ? false : _g, // 默认展开状态
    _h = _a.labelWidth, // 默认展开状态
    labelWidth = _h === void 0 ? 100 : _h;
    var form = Form.useForm()[0];
    var _j = useState(defaultCollapsed), collapsed = _j[0], setCollapsed = _j[1];
    // 处理搜索
    var handleSearch = function () {
        console.log("[GenericPanelSearch] 搜索按钮被点击");
        form
            .validateFields()
            .then(function (values) {
            console.log("[GenericPanelSearch] 表单验证成功，搜索值:", values);
            onSearch(values);
        })
            .catch(function (errorInfo) {
            console.log("[GenericPanelSearch] 表单验证失败:", errorInfo);
            // 即使验证失败，也执行搜索（使用当前表单值）
            var currentValues = form.getFieldsValue();
            console.log("[GenericPanelSearch] 使用当前表单值进行搜索:", currentValues);
            onSearch(currentValues);
        });
    };
    // 重置表单
    var handleReset = function () {
        console.log("[GenericPanelSearch] 重置按钮被点击");
        form.resetFields();
        console.log("[GenericPanelSearch] 表单已重置");
        // 如果有onReset回调，优先调用onReset，否则执行空搜索
        if (onReset) {
            console.log("[GenericPanelSearch] 调用onReset回调");
            onReset();
        }
        else {
            console.log("[GenericPanelSearch] 执行空搜索");
            onSearch({});
        }
    };
    // 切换折叠状态
    var toggleCollapse = function () {
        setCollapsed(!collapsed);
    };
    // 计算每个表单项占用的列数
    var getColSpan = function (item) {
        if (item.colSpan)
            return item.colSpan;
        return 24 / columns;
    };
    // 根据折叠状态确定显示的项目
    var visibleItems = collapsed && collapsible ? searchItems.slice(0, columns) : searchItems;
    // 渲染搜索控件
    var renderFormItem = function (item) {
        var type = item.type, options = item.options, _a = item.props, props = _a === void 0 ? {} : _a, customComponent = item.customComponent;
        switch (type) {
            case "input":
                return _jsx(Input, __assign({ allowClear: true }, props));
            case "select":
                return (_jsx(Select, __assign({ allowClear: true }, props, { children: options === null || options === void 0 ? void 0 : options.map(function (opt) { return (_jsx(Option, __assign({ value: opt.value }, { children: opt.label }), opt.value)); }) })));
            case "date":
                return _jsx(DatePicker, __assign({ style: { width: "100%" } }, props));
            case "dateRange":
                return _jsx(RangePicker, __assign({ style: { width: "100%" } }, props));
            case "number":
                return _jsx(Input, __assign({ type: "number", allowClear: true }, props));
            case "inputNumber": // 添加这个 case
                return _jsx(InputNumber, __assign({ style: { width: "100%" } }, props));
            case "switch":
                return _jsx(Switch, __assign({}, props));
            case "custom":
                if (customComponent) {
                    var CustomComponent = customComponent;
                    return _jsx(CustomComponent, __assign({}, props));
                }
                return _jsx(Input, __assign({ allowClear: true }, props));
            default:
                return _jsx(Input, __assign({ allowClear: true }, props));
        }
    };
    // 构建所有操作按钮
    var actionButtons = (_jsxs(Space, { children: [collapsible && searchItems.length > columns && (_jsx(Button, __assign({ type: "link", onClick: toggleCollapse, icon: collapsed ? _jsx(DownOutlined, {}) : _jsx(UpOutlined, {}), style: {
                    color: "#1890ff",
                } }, { children: collapsed ? "更多" : "收拢" }))), _jsx(Button, __assign({ icon: _jsx(ReloadOutlined, {}), size: "small", onClick: handleReset, style: {
                    color: "#1890ff",
                    borderColor: "#1890ff",
                    fontSize: "12px",
                } }, { children: "\u91CD\u7F6E" })), _jsx(Button, __assign({ type: "primary", size: "small", icon: _jsx(SearchOutlined, {}), onClick: handleSearch, style: {
                    fontSize: "12px",
                } }, { children: "\u641C\u7D22" }))] }));
    // 计算标签宽度的样式
    var labelColStyle = {
        width: typeof labelWidth === "number" ? "".concat(labelWidth, "px") : labelWidth,
        textAlign: "right",
    };
    return (_jsx(Card, __assign({ title: _jsx("span", __assign({ style: { color: "#1f1f1f", fontWeight: 500 } }, { children: title })), extra: actionButtons, className: "search-panel", styles: { body: { padding: "24px 24px 0 24px" } } }, { children: _jsx(Form, __assign({ form: form, layout: "horizontal" }, { children: _jsx(Row, __assign({ gutter: 16 }, { children: visibleItems.map(function (item) { return (_jsx(Col, __assign({ span: getColSpan(item), style: { marginBottom: 16 } }, { children: _jsx(Form.Item, __assign({ name: item.name, label: _jsx("span", __assign({ style: { color: "#1f1f1f" } }, { children: item.label })), style: { marginBottom: 0 }, 
                        // 应用固定宽度到标签
                        labelCol: { style: labelColStyle }, initialValue: item.initialValue }, { children: renderFormItem(item) })) }), item.name)); }) })) })) })));
};
export default GenericPanelSearch;
